import { useState } from "react";
import { Dropdown } from "react-bootstrap";
import styles from "../Categories.module.scss";
import { ConfirmationModal } from "../../../general/ConfirmationModal";
import { CategoryFlattenedItem } from "../utils";
import { useDeleteCustomCategoryMutation } from "../../../../api/category.api";
import { PlainModal } from "../../../general/Modal/Modal";
import { ManagementDropdown } from "../../../general/ManagementDropdown/ManagementDropdown";
import { UpdateCategoryModal } from "../UpdateCategoryModal";
import { pluralize } from "../../../../common/helpers/string";

export const CategoryActions: React.FC<{
    category: CategoryFlattenedItem;
    onDelete?: () => void;
    transactionsCount: number;
}> = ({ category, transactionsCount }) => {
    const deleteCategory = useDeleteCustomCategoryMutation(
        category.meta.category!,
    );
    const [showDeleteModal, setShowDeleteModal] = useState(false);

    const [showChangeDescriptionModal, setShowChangeDescriptionModal] =
        useState(false);

    return (
        <div onPointerDown={(e) => e.stopPropagation()}>
            <ManagementDropdown
                id={`class-actions-dropdown__${category.id}`}
                popperConfigStrategy="fixed"
                className={styles.dropdownButton}
            >
                <Dropdown.Item
                    onClick={(e) => {
                        e.stopPropagation();
                        setShowChangeDescriptionModal(true);
                    }}
                >
                    Update
                </Dropdown.Item>
                <Dropdown.Item
                    onClick={(e) => {
                        e.stopPropagation();
                        setShowDeleteModal(true);
                    }}
                    className={styles.deleteItem}
                >
                    Delete
                </Dropdown.Item>
            </ManagementDropdown>

            <PlainModal
                show={showChangeDescriptionModal}
                onHide={() => setShowChangeDescriptionModal(false)}
            >
                <UpdateCategoryModal
                    category={category.meta.category!}
                    onHide={() => setShowChangeDescriptionModal(false)}
                />
            </PlainModal>

            <ConfirmationModal
                show={showDeleteModal}
                onHide={() => setShowDeleteModal(false)}
                title={`Are you sure that you want to delete subcategory: ${category.meta.label}?`}
                question={
                    transactionsCount > 0
                        ? `This category has ${transactionsCount} ${pluralize("transaction", transactionsCount)} associated with it.`
                        : ""
                }
                no="Cancel"
                onReject={() => setShowDeleteModal(false)}
                onConfirm={() => {
                    deleteCategory.mutate();
                    setShowDeleteModal(false);
                }}
                yes="Delete"
            />
        </div>
    );
};
